import React, { useEffect, useState } from 'react'

import CourseSection from './Course'
import IndividualClassSection from './IndividualClass'
import ProgressSection from './ProgressSection'
import { ChallengesProvider } from '../../../../context/ChallengesContext'
import { INITIAL_VALUE } from '../../../../pages/ChallengePage'
import { WelcomeModal } from '../../../modal'

const Dashoboard = ({ type }: { type?: string }) => {
  const [showModal, setShowModal] = useState(false)
  const initialChallenge = INITIAL_VALUE

  useEffect(() => {
    const hasForm = localStorage.getItem('hasForm')

    if (hasForm === 'false') {
      setShowModal(true)
    } else {
      setShowModal(false)
    }
  }, [])

  return (
    <ChallengesProvider initialState={initialChallenge}>
      {showModal && (
        <WelcomeModal showModal={showModal} setShowModal={setShowModal} />
      )}

      <ProgressSection />
      {type === 'class' ? <IndividualClassSection /> : <CourseSection />}
    </ChallengesProvider>
  )
}

export default Dashoboard
